import { FC } from 'react';

const COLS = ['Фото', 'Название', 'Обьем', 'Количество', 'Цена', ''];

import styles from './cartListHeader.module.scss';

const CartListHeader: FC = () => {
  return (
    <ul className={styles.list}>
      {COLS.map((item, index) => {
        return (
          <li key={index} className={styles.list__item}>
            <p className={styles.list__text}>{item}</p>
          </li>
        );
      })}
    </ul>
  );
};

export default CartListHeader;
